<template>
	<div>
		<Header />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/banner.png`" />
			<cloud />
		</div>
		<div class="TabWrap">
			<div :class="{on:routeName=='notice'}">信息批露</div>
			<div :class="{on:routeName=='coList'}">公司治理</div>
			<div :class="{on:routeName=='stock'}">股票信息</div>
		</div>
		<div class="notice-content">
			<router-view :key="$route.path" />
		</div>
	</div>
</template>

<script>
import cloud from '../components/cloud.vue'
	export default {
  components: { cloud },
		data() {
			return {
				
			}
		},
		created() {
			console.log(this.$route)
		},
		computed:{
			routeName: function(){
           		return this.$route.name
			}
		},
		methods: {
			
		}
	}
</script>
<style lang="scss" scoped>
	.bannerWrap{
		position: relative;
		width: 100%;
		height: 5.19rem;
		.bannerImg {
			width: 100%;
		}
	}
	.TabWrap {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 100%;
		height: 0.88rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 5px 0px rgba(22, 26, 26, 0.1);
		margin-top: 0.25rem;
		>div {
			height: 100%;
			line-height: 0.88rem;
			text-align: center;
			font-size: 0.1rem;
			color: #161A1A;
			box-sizing: border-box;
			&.on {
				color: #161A1A;
				font-weight: bold;
				border-bottom: 0.06rem solid #161A1A;
			}
		}
	}
	.notice-content{
		padding: 0 0.82rem;
		box-sizing: border-box;
	}
</style>


// WEBPACK FOOTER //
// src/views/index.vue